import { render, staticRenderFns } from "./ModuleRelatedList.vue?vue&type=template&id=d19b08c6"
import script from "./ModuleRelatedList.vue?vue&type=script&lang=js"
export * from "./ModuleRelatedList.vue?vue&type=script&lang=js"
import style0 from "./ModuleRelatedList.vue?vue&type=style&index=0&id=d19b08c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports